var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"date__circle"},[_vm._v("\n    "+_vm._s(_vm.date.getDate())+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }